import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { svgimages } from "../../../utils/svgimages";
import sendMagicLinkEmail from "../../../utils/sendMagicLink";

const MagicLink = () => {
  const [email, setEmail] = useState<string>("");
  const [magicLinkSent, setMagicLinkSent] = useState<boolean>(false);

  const sendMagicLink = async () => {
    try {
      await sendMagicLinkEmail(email);
      setMagicLinkSent(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {!magicLinkSent ? (
        <Grid container>
          <Grid item xs={2} md={4.5}></Grid>
          <Grid item xs={8} md={3}>
            <Box textAlign={"center"} marginTop={2}>
              <img
                width="100%"
                src={svgimages["equilaw-logo"]}
                alt="Equilawlogo1651"
              />
            </Box>
          </Grid>
          <Grid item xs={2} md={4.5}></Grid>
          <Grid item xs={2} md={4.5}></Grid>
          <Grid item xs={8} md={3}>
            <Box marginTop={8}>
              <Typography variant="body1">
                Generate a one-time link that will be valid for 10 minutes and
                allow you to access your account via an email.
              </Typography>
              <br />
              <br />
              <InputLabel
                sx={{ textAlign: "left", marginBottom: "2vh" }}
                htmlFor="email"
              >
                Email
              </InputLabel>
              <TextField
                onChange={(event) => setEmail(event.target.value)}
                value={email}
                fullWidth
                id="email"
                name="email"
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box textAlign={"center"}>
              <Button
                onClick={sendMagicLink}
                variant="contained"
                sx={{ bgcolor: "#DE8646", mt: 5 }}
              >
                Generate One Time Link
              </Button>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          <Grid container>
            <Grid item xs={2} md={4.5}></Grid>
            <Grid item xs={8} md={3}>
              <Box textAlign={"center"} marginTop={2}>
                <img
                  width="100%"
                  src={svgimages["equilaw-logo"]}
                  alt="Equilawlogo1651"
                />
              </Box>
            </Grid>
            <Grid item xs={2} md={4.5}></Grid>
          </Grid>
          <Grid item xs={2} md={4.5}></Grid>
          <Grid item xs={8} md={3}>
            <Box marginTop={8}>
              <Typography variant="body1">
                Please check your email for a one-time link that will enable you
                to login which will be valid for 10 minutes.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2} md={4.5}></Grid>
        </Grid>
      )}
    </>
  );
};

export default MagicLink;
